export default __webpack_public_path__ + "assets/images/icon-attention.6e97eb4b0ed487d3f587169c9cb5a027.svg";